import { LinearGradient } from "expo-linear-gradient";
import React from "react";
import { View, StyleSheet, Animated, ViewStyle } from "react-native";

import { COLORS } from "../../theme/colors";
import { SHADOWS } from "../../theme/shadows";

type PremiumProgressBarProps = {
  progress: number; // 0 to 1
  style?: ViewStyle;
  height?: number;
  gradientColors?: string[];
};

const PremiumProgressBar: React.FC<PremiumProgressBarProps> = ({
  progress,
  style,
  height = 12,
  gradientColors,
}) => {
  return (
    <View style={[styles.container, style, { height }]}> 
      <Animated.View style={[styles.animatedBar, { width: `${progress * 100}%`, height }]}> 
        <LinearGradient
          colors={(gradientColors || COLORS.gradientPrimary) as [string, string]}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 1 }}
          style={[StyleSheet.absoluteFill, styles.gradient]}
        />
      </Animated.View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: COLORS.primaryLight,
    borderRadius: 8,
    overflow: "hidden",
    ...SHADOWS.card,
  },
  animatedBar: {
    borderRadius: 8,
    overflow: "hidden",
  },
  gradient: {
    flex: 1,
    borderRadius: 8,
  },
});

export default PremiumProgressBar;
